import styles from './Dashboard.module.css';
import MainContentPending from '../../pageStructure/mainContentPending/index';
import ApplyFlexiLoanInfoView from '../../applyFlexiLoanView/ApplyFlexiLoanInfoView/ApplyFlexiLoanInfoView';
import { useStateKey } from '../../../iwQueryClient/useStateKey';
import { useQuery } from '@tanstack/react-query';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { OutstandingLoanView } from './outstandingLoanView/OutstandingLoanView';
import { trackPageView } from '../../../tracking/pageView';
import { useEffect } from 'react';

const Dashboard = () => {
    const stateKey = useStateKey();
    const { isLoading, data: getAccountsResponse } = useQuery(
        getAccountsQueryConfig(stateKey)
    );

    useEffect(() => {
        if (stateKey) {
            trackPageView(stateKey, 'CBILS Dashboard');
        }
    }, [stateKey]);

    if (isLoading) {
        return <MainContentPending data-testid="cbils-dashboard-loading" />;
    }

    if (getAccountsResponse && getAccountsResponse.data) {
        let dashboardStatus: 'offered' | 'ineligible' = 'ineligible';

        const firstCBILSLoan = getAccountsResponse.data.accounts.find(
            (account) => account.product_type === 'cbils'
        );

        if (firstCBILSLoan) {
            if (
                ['ongoing', 'topup', 'overdue', 'duetoday'].includes(
                    firstCBILSLoan.loan_status!
                )
            ) {
                dashboardStatus = 'offered';
            }

            switch (dashboardStatus) {
                case 'offered':
                    return (
                        <div className={styles.Dashboard}>
                            <OutstandingLoanView account={firstCBILSLoan} />
                        </div>
                    );

                default:
                    return <ApplyFlexiLoanInfoView />;
            }
        }
        return <ApplyFlexiLoanInfoView />;
    }
    return null;
};

export const CBILSDashboard = Dashboard;
